<template>
  <div class="box text-left">
    <!-- /.box-header -->
    <div class="box-body form">
      <br />
      <div class="del-block" v-if="info && show.delBtn">
        <div class="btn btn-danger" data-toggle="modal" data-target="#delModal">刪除群組</div>
      </div>
      <div v-if="info">
        <div class="input-group">
          <span class="input-group-addon">群組ID</span>
          <div class="form-control form-info">
            {{info.id}}
          </div>
        </div>
        <br />
      </div>
      <div>
        <div class="input-group">
        <span class="input-group-addon">
          <span class="text-red">＊ </span>群組名稱
        </span>
          <input class="form-control" placeholder="" type="text" v-model="brandName" maxlength="45">
        </div>
        <br />
      </div>
      <div v-if="info">
        <div class="input-group">
          <span class="input-group-addon">建立時間</span>
          <div class="form-control form-info">
            {{info.create_time}}
          </div>
        </div>
        <br />
      </div>
      <div v-if="info">
        <div class="input-group">
          <span class="input-group-addon">更新時間</span>
          <div class="form-control form-info">
            {{info.edit_time}}
          </div>
        </div>
        <br />
      </div>
      <div v-if="info">
        <div class="input-group">
          <span class="input-group-addon">綁定店家</span>
          <div class="form-control form-info">
            <div class="btn btn-default" @click="goToStoreTable()">
              綁定其他店家
            </div>
            <br>
            <div v-for="store in info.stores" class="label-stores inline-block m-y-10">
              <span class="label label-primary c-pointer" @click="goToEditStore(store.store_id)">{{store.store_name}} ({{store.store_id}})</span>
              <br>
            </div>
          </div>
        </div>
        <br />
      </div>
    </div>
    <div class="box-footer text-center">
      <router-link :to="{path: '/groupTable/' + $route.params.brand_id}" class="text-white">
        <button class="btn btn-default">
          取消
        </button>
      </router-link>
      <button class="btn btn-success" v-if="!info" @click="addGroup()">
        新增
      </button>
      <button class="btn btn-success" v-if="info" @click="upGroup()">
        修改
      </button>
    </div>
    <br />
    <m-modal class="text-left" :option="delOption" @trigger="trigger"></m-modal>
  </div>
</template>
<script>
import matcherModal from '../../../elements/Modal.vue'
// import $ from 'jquery'
// import 'src/static/js/plugins/notify/notify.min.js'
export default {
  props: {
    'info': {
      type: Object
    }
  },
  data () {
    return {
      brandName: '',
      show: {
        delBtn: false
      },
      delOption: {
        id: 'delModal',
        title: '刪除群組',
        body: '確定刪除群組?',
        btns: [
          {
            name: '取消'
          },
          {
            name: '確定',
            event: 'delGroup'
          }
        ]
      }
    }
  },
  methods: {
    addAdRow () {
      this.adRowNum = this.adRowNum + 1
    },
    delAdRow () {
      this.adRowNum = this.adRowNum - 1
    },
    addGroup () {
      var self = this
      if (this.getInput.name) {
        var data = {
          name: this.getInput.name
        }
        var url = '/brand/' + this.$route.params.brand_id + '/storeGroup'
        this.getDataH('post', url, data, function (response) {
          if (response.data.status === 200) {
            self.$notify({
              title: response.data.message,
              text: response.data.description,
              duration: 3000,
              type: 'success',
              width: 400
            })
            self.$router.push({path: '/groupTable/' + self.$route.params.brand_id})
          }
        })
      } else {
        this.$notify({
          title: '提醒',
          text: '群組名稱不可為空',
          duration: 3000,
          type: 'danger',
          width: 400
        })
      }
    },
    upGroup () {
      var self = this
      if (this.getInput.name) {
        var data = {
          name: this.getInput.name
        }
        var url = '/brand/' + this.$route.params.brand_id + '/storeGroup/' + this.$route.params.group_id
        this.getDataH('put', url, data, function (response) {
          if (response.data.status === 200) {
            self.$notify({
              title: response.data.message,
              text: response.data.description,
              duration: 3000,
              type: 'success',
              width: 400
            })
            self.$router.push({path: '/groupTable/' + self.$route.params.brand_id})
          }
        })
      } else {
        this.$notify({
          title: '提醒',
          text: '群組名稱不可為空',
          duration: 3000,
          type: 'danger',
          width: 400
        })
      }
    },
    delGroup () {
      var self = this
      var url = '/brand/' + this.$route.params.brand_id + '/storeGroup/' + this.$route.params.group_id
      this.getDataH('delete', url, null, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: response.data.message,
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          })
          self.$router.push({path: '/groupTable/' + self.$route.params.brand_id})
        }
      })
    },
    goToStoreTable () {
      this.$router.push({path: '/storeTable/' + this.$route.params.brand_id})
    },
    goToEditStore (storeId) {
      this.$router.push({path: '/upStore/' + this.$route.params.brand_id + '/' + storeId})
    },
    trigger (event) {
      if (event === 'delGroup') {
        this.delGroup()
      }
    }
  },
  computed: {
    checkInput () {
      return this.$parent.checkInput
    },
    getDataH () {
      return this.$parent.getDataH
    },
    getInput () {
      return {
        name: this.checkInput(this.brandName.toString())
      }
    }
  },
  watch: {
    info () {
      this.brandName = this.info.name
      if (this.info.stores) {
        if (!this.info.stores.length) this.show.delBtn = true
      }
    }
  },
  components: {
    'm-modal': matcherModal
  }
}
</script>



// WEBPACK FOOTER //
// GroupFormTemp.vue?4ca4cabd